import { format, parse } from 'date-fns';
import React from 'react';

const inputelement = ({value, errors, Label, elementName, handleRegChange, maxLength}) => {
    const formatDate = (date, targetElementName)=> {
        if (date === null || date === undefined || date === '') {
            return '';
        }

        if (targetElementName === 'DOB' || targetElementName === 'EventDate' || targetElementName === 'RegistrationEndDate') {
            if (typeof date === 'string') {
                const trimmedDate = date.trim();
                if (/^\d{4}-\d{2}-\d{2}$/.test(trimmedDate)) {
                    return trimmedDate;
                }

                if (/^\d{2}-\d{2}-\d{4}$/.test(trimmedDate)) {
                    const parsedDate = parse(trimmedDate, 'dd-MM-yyyy', new Date());
                    return format(parsedDate, 'yyyy-MM-dd');
                }
            }

            const parsedDate = date instanceof Date ? date : new Date(date);
            if (!Number.isNaN(parsedDate.getTime())) {
                return format(parsedDate, 'yyyy-MM-dd');
            }
        }

        return date;
      }
  const inputType = elementName === 'MobileNo'
    ? 'tel'
    : elementName === 'DOB' || elementName === 'EventDate' || elementName === 'RegistrationEndDate'
      ? 'date'
      : 'text';

  return <div>
    <label htmlFor="name" className="block text-sm font-medium text-label-clr pl-1">
        {Label}
    </label>
    <input
        type={inputType}
        inputMode={elementName === 'MobileNo' ? 'numeric' : undefined}
        pattern={elementName === 'MobileNo' ? '[0-9]*' : undefined}
        id={elementName}
        name={elementName}
        value={formatDate(value, elementName)}
        autoComplete="off"
        maxLength={maxLength}
        className="bg-input-bg mt-1 block w-full px-3 py-3 border border-gray-300 rounded-md shadow-sm focus:ring-indigo-500 focus:border-indigo-500 sm:text-sm"
        placeholder=""
        onChange={handleRegChange}
    />
    {errors && (
        <p className="text-red-500 text-sm mt-1">{errors}</p>
    )}
    </div>;
};

export default inputelement;